const getTitle = (title: string) => {
  if (title) {
    if (title?.length < 50) {
      return title;
    } else {
      return title?.slice(0, 50) + '...';
    }
  } else {
    return '';
  }
};

const getDescription = (description?: string | null): string => {
  if (!description || description == 'null') {
    return '';
  }

  const result =
    description.length < 150 ? description : description.slice(0, 150) + '...';

  return result;
};
const getDate = (boxDate: string, monthNames: string[]) => {
  return (
    new Date(boxDate).getDate() +
    ' ' +
    monthNames[Number(new Date(boxDate).getMonth())] +
    ' ' +
    new Date(boxDate).getFullYear()
  );
};

const redirect = (url: string) => {
  window.open(url, '_blank');
};

import { Notifications } from '@/types/notificationTypes';
import { ComponentInternalInstance } from 'vue';

const csNotify = (
  instance: ComponentInternalInstance | null,
  text: string,
  type?: string
) => {
  const instanceProxy: any = instance?.proxy;
  if (instanceProxy.csNotify) {
    instanceProxy.csNotify(
      text,
      type ? `important-${type}` : `important-${Notifications.INFO}`,
      {},
      { iconEnabled: false, isAutomaticallyClosed: true }
    );
  }
};

const csNotifyTimer = (
  instance: ComponentInternalInstance | null,
  loggedInCallback: () => void,
  timerEndedCallback: () => void,
  loggedInTime: number,
  timerEndedTime: number
) => {
  const instanceProxy: any = instance?.proxy;
  if (instanceProxy.csNotifyTimer) {
    const notifyTimerId = instanceProxy.csNotifyTimer(
      loggedInCallback,
      timerEndedCallback,
      loggedInTime,
      timerEndedTime
    );
    return notifyTimerId;
  }
};

const csCloseAllNotifications = (
  instance: ComponentInternalInstance | null
) => {
  const instanceProxy: any = instance?.proxy;
  if (instanceProxy.csCloseAllNotifications) {
    instanceProxy.csCloseAllNotifications();
  }
};

const csCloseNotification = (
  instance: ComponentInternalInstance | null,
  notifyTimerId: number
) => {
  const instanceProxy: any = instance?.proxy;
  if (instanceProxy.csCloseNotification) {
    instanceProxy.csCloseNotification(notifyTimerId);
  }
};

export {
  getTitle,
  getDate,
  redirect,
  getDescription,
  csNotify,
  csNotifyTimer,
  csCloseAllNotifications,
  csCloseNotification,
};
